import React, { useState, useEffect, useCallback } from 'react';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { Selector, Option } from '../Selects/Selector';

export interface ExaminedSelectorProps {
  readOnly?: boolean;
  value?: string | null;
  placeholder?: string;
  className?: string;
  clearable?: boolean;
  onChange?: (option: Option) => void;
  refreshKey?: number;
  showNipOrPesel?: boolean;
}

export const ExaminedSelector: React.FC<ExaminedSelectorProps> = props => {
  const spd = useSpdCore();
  const [displayName, setDisplayName] = useState<string>('');

  useEffect(() => {
    let mounted = true;
    if (props.value) {
      spd.examineds
        .getExamined(props.value || '')
        .then(examined => {
          if (mounted) {
            if (examined) {
              let identifier: string;
              if (props.showNipOrPesel) {
                identifier = examined.nip
                  ? '(NIP: ' + examined.nip + ')'
                  : examined.pesel
                    ? '(PESEL: ' + examined.pesel + ')'
                    : '';
              } else {
                identifier = examined.pesel
                  ? '(PESEL: ' + examined.pesel + ')'
                  : '';
              }
              setDisplayName(
                `${examined.surname || ''} ${examined.firstname || ''} ${identifier}`.trim(),
              );
            } else {
              setDisplayName('');
            }
          }
        })
        .catch(error => {
          console.error('błąd ładowania badanego: ', error);
        });
    }
    return () => {
      mounted = false;
    };
  }, [props.value, props.refreshKey, props.showNipOrPesel, spd.examineds]);

  const provider = useCallback(
    (text: string) => {
      return props.showNipOrPesel
        ? spd.examineds.getOptionsByNameOrNipOrPesel(text)
        : spd.examineds.getOptionsByNameOrPesel(text);
    },
    [props.showNipOrPesel, spd.examineds],
  );

  return (
    <Selector
      uniqueKey={'examined-' + displayName + JSON.stringify(props.value)}
      className={props.className}
      readOnly={props.readOnly}
      creatable={false}
      placeholder={props.placeholder || 'Wskaż badanego...'}
      provider={provider}
      value={displayName}
      onChange={props.onChange}
      clearable={props.clearable}
    />
  );
};
